import React, { FC, InputHTMLAttributes } from "react";
import { ILogin } from "../../../../utils/types";
import "./styleComponents.css";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  login: ILogin;
  handleChange(field: any, value: string): void;
}

const LoginUsernameInput: FC<InputProps> = ({
  login,
  handleChange,
  ...prop
}) => {
  const labelText = prop.placeholder?.toString() || "Email";
  
  return (
    <div>
      <input
        className="loginInput"
        type="text"
        placeholder={labelText}
        value={login.username}
        onChange={(e) => handleChange("username", e.target.value)}
        autoComplete="username"
      />
    </div>
  );
};

export default LoginUsernameInput;
